import React from 'react';
export const InvoiceTab = props => {
	const { text } = props;

	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 90 82.02'>
			<defs>
				<clipPath id='a' transform='translate(0 0.02)'>
					<rect width='90.08' height='82' fill='none' />
				</clipPath>
				<clipPath id='b' transform='translate(0 0.02)'>
					<path
						d='M57.73,33.26l-.95-1a.59.59,0,0,0,.59-.62l1,1A.6.6,0,0,1,57.73,33.26Z'
						fill='none'
					/>
				</clipPath>
				<clipPath id='c' transform='translate(0 0.02)'>
					<path d='M55.89,33.1l-.94-1a.5.5,0,0,0,.38.16l.94,1A.5.5,0,0,1,55.89,33.1Z' fill='none' />
				</clipPath>
				<clipPath id='d' transform='translate(0 0.02)'>
					<path
						d='M54.24,34.52l-.94-1a1.89,1.89,0,0,1-.55-1.42l1,1A1.92,1.92,0,0,0,54.24,34.52Z'
						fill='none'
					/>
				</clipPath>
				<clipPath id='e' transform='translate(0 0.02)'>
					<path
						d='M57.45,24.83l.94,1a.6.6,0,0,1,.16.46l-.94-1A.6.6,0,0,0,57.45,24.83Z'
						fill='none'
					/>
				</clipPath>
				<clipPath id='f' transform='translate(0 0.02)'>
					<path
						d='M59.09,23.41l.94,1a2,2,0,0,0-1.41-.58l-.94-1A1.94,1.94,0,0,1,59.09,23.41Z'
						fill='none'
					/>
				</clipPath>
				<clipPath id='g' transform='translate(0 0.02)'>
					<path
						d='M54,25.82l-.94-1a2.11,2.11,0,0,1,2.08-2l.95,1A2.12,2.12,0,0,0,54,25.82Z'
						fill='none'
					/>
				</clipPath>
				<clipPath id='h' transform='translate(0 0.02)'>
					<path
						d='M72.44,33.19l-.94-1a.59.59,0,0,0,.6-.61l.94,1A.59.59,0,0,1,72.44,33.19Z'
						fill='none'
					/>
				</clipPath>
				<clipPath id='i' transform='translate(0 0.02)'>
					<path d='M71,33l-.94-1a.49.49,0,0,0,.38.15l.94,1A.52.52,0,0,1,71,33Z' fill='none' />
				</clipPath>
				<clipPath id='j' transform='translate(0 0.02)'>
					<path
						d='M69.34,34.53l-.94-1a1.94,1.94,0,0,1-.55-1.44l.94,1A1.94,1.94,0,0,0,69.34,34.53Z'
						fill='none'
					/>
				</clipPath>
				<clipPath id='k' transform='translate(0 0.02)'>
					<path
						d='M72.17,24.87l.94,1a.6.6,0,0,1,.16.46l-.94-1A.6.6,0,0,0,72.17,24.87Z'
						fill='none'
					/>
				</clipPath>
				<clipPath id='l' transform='translate(0 0.02)'>
					<path
						d='M73.79,23.38l.94,1a1.93,1.93,0,0,0-1.4-.58l-.94-1A1.93,1.93,0,0,1,73.79,23.38Z'
						fill='none'
					/>
				</clipPath>
				<clipPath id='m' transform='translate(0 0.02)'>
					<path
						d='M69.06,25.82l-.94-1a2.09,2.09,0,0,1,2.06-2.05l.95,1A2.1,2.1,0,0,0,69.06,25.82Z'
						fill='none'
					/>
				</clipPath>
			</defs>
			<title>2.1.1_Invoices_Current_INV#Banner_90x82</title>
			<g clip-path='url(#a)'>
				<path
					d='M11.39,0H58.06S68.74-1.19,68.74,13.75H0C0,4.39,5.45,0,11.38,0Z'
					transform='translate(0 0.02)'
					fill='#2262ae'
				/>
				<path
					d='M12.46,0c2.6.19,9,1.85,9,13.75V82H90V13.75C90,4.39,78.34,0,72.41,0Z'
					transform='translate(0 0.02)'
					fill='#2a7de1'
				/>
			</g>
			<g>
				<polygon
					points='32.33 23.99 31.93 34.96 29.92 34.96 30.32 23.99 32.33 23.99'
					fill='#cfd2d3'
				/>
				<polygon
					points='29.92 34.96 28.98 33.99 29.38 23.02 30.32 23.99 29.92 34.96'
					fill='#707071'
				/>
				<polygon
					points='30.32 23.99 29.38 23.02 31.39 23.02 32.33 23.99 30.32 23.99'
					fill='#929394'
				/>
			</g>
			<g>
				<polygon points='39.83 34.96 38.89 33.99 39 31.02 39.94 31.98 39.83 34.96' fill='#707071' />
				<polygon points='39.94 31.98 39 31.02 36.56 26.82 37.51 27.79 39.94 31.98' fill='#707071' />
				<polygon
					points='40.05 28.91 39.11 27.95 39.29 23.02 40.23 23.99 40.05 28.91'
					fill='#707071'
				/>
				<polygon
					points='40.23 23.99 39.29 23.02 41.26 23.02 42.2 23.99 40.23 23.99'
					fill='#929394'
				/>
				<polygon
					points='42.2 23.99 41.79 34.96 39.83 34.96 39.94 31.98 37.51 27.79 37.24 34.96 35.28 34.96 35.68 23.99 37.23 23.99 40.05 28.91 40.23 23.99 42.2 23.99'
					fill='#cfd2d3'
				/>
				<polygon
					points='35.28 34.96 34.34 33.99 34.74 23.02 35.68 23.99 35.28 34.96'
					fill='#707071'
				/>
				<polygon
					points='35.68 23.99 34.74 23.02 36.29 23.02 37.23 23.99 35.68 23.99'
					fill='#929394'
				/>
			</g>
			<g>
				<polygon
					points='48.08 31.6 47.13 30.63 48.92 23.02 49.87 23.99 48.08 31.6'
					fill='#707071'
				/>
				<polygon
					points='49.87 23.99 48.92 23.02 50.98 23.02 51.93 23.99 49.87 23.99'
					fill='#929394'
				/>
				<polygon
					points='51.93 23.99 48.83 34.97 47.02 34.97 44.7 23.99 46.83 23.99 48.08 31.6 49.87 23.99 51.93 23.99'
					fill='#cfd2d3'
				/>
				<polygon
					points='47.02 34.97 46.08 34.01 43.76 23.02 44.7 23.99 47.02 34.97'
					fill='#707071'
				/>
				<polygon
					points='44.7 23.99 43.76 23.02 45.88 23.02 46.83 23.99 44.7 23.99'
					fill='#929394'
				/>
			</g>
			<g>
				<g>
					<g clip-path='url(#b)'>
						<g>
							<path
								d='M57.73,33.26l-.95-1h0l.94,1h0'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
							<path
								d='M57.76,33.26l-.94-1,.09,0,.94,1-.09,0'
								transform='translate(0 0.02)'
								fill='#898a8b'
							/>
							<path
								d='M57.85,33.24l-.94-1,.07,0,1,1-.08,0'
								transform='translate(0 0.02)'
								fill='#858587'
							/>
							<path
								d='M57.93,33.22l-1-1,.07,0,.94,1-.06,0'
								transform='translate(0 0.02)'
								fill='#808182'
							/>
							<path
								d='M58,33.2l-.94-1,.06,0,1,1-.07,0'
								transform='translate(0 0.02)'
								fill='#7d7e7f'
							/>
							<path
								d='M58.06,33.16l-1-1,.07-.06.94,1-.06.06'
								transform='translate(0 0.02)'
								fill='#79797a'
							/>
							<path
								d='M58.12,33.1l-.94-1a.63.63,0,0,0,.19-.46l1,1a.67.67,0,0,1-.2.46'
								transform='translate(0 0.02)'
								fill='#747476'
							/>
						</g>
					</g>
				</g>
				<polygon
					points='56.27 33.28 55.33 32.31 56.78 32.31 57.73 33.28 56.27 33.28'
					fill='#929394'
				/>
				<g>
					<g clip-path='url(#c)'>
						<g>
							<path
								d='M55.89,33.1l-.94-1,0,0,1,1,0,0'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
							<path
								d='M55.93,33.13l-1-1a.48.48,0,0,0,.26.12l.94,1a.53.53,0,0,1-.25-.12'
								transform='translate(0 0.02)'
								fill='#929394'
							/>
							<path
								d='M56.18,33.25l-.94-1h.09l.94,1h-.09'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
						</g>
					</g>
				</g>
				<g>
					<g clip-path='url(#d)'>
						<g>
							<path
								d='M54.24,34.52l-.94-1a1.89,1.89,0,0,1-.55-1.42l1,1a1.92,1.92,0,0,0,.54,1.42'
								transform='translate(0 0.02)'
								fill='#747476'
							/>
						</g>
					</g>
				</g>
				<polygon
					points='58.32 32.66 57.38 31.69 57.61 25.31 58.55 26.28 58.32 32.66'
					fill='#707071'
				/>
				<g>
					<g clip-path='url(#e)'>
						<g>
							<path
								d='M58.55,26.26l-.94-1a.6.6,0,0,0-.16-.46l.94,1a.6.6,0,0,1,.16.46'
								transform='translate(0 0.02)'
								fill='#747476'
							/>
						</g>
					</g>
				</g>
				<g>
					<g clip-path='url(#f)'>
						<g>
							<path
								d='M58.62,23.79l-.94-1a1.66,1.66,0,0,1,.32,0l.94,1a1.66,1.66,0,0,0-.32,0'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
							<path
								d='M58.94,23.82l-.94-1a2,2,0,0,1,1,.43l.94,1a2,2,0,0,0-1-.43'
								transform='translate(0 0.02)'
								fill='#929394'
							/>
							<path
								d='M59.9,24.25l-.94-1,.13.13.94,1-.13-.12'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
						</g>
					</g>
				</g>
				<polygon
					points='56.05 23.82 55.1 22.84 57.68 22.84 58.62 23.82 56.05 23.82'
					fill='#929394'
				/>
				<polygon
					points='53.7 33.13 52.76 32.16 53.02 24.87 53.96 25.84 53.7 33.13'
					fill='#707071'
				/>
				<path
					d='M58.62,23.79a1.92,1.92,0,0,1,2,2l-.26,7.28a2.1,2.1,0,0,1-2.1,2H55.63a1.92,1.92,0,0,1-1.93-2L54,25.82a2.12,2.12,0,0,1,2.09-2Zm-.3,8.85.23-6.38a.55.55,0,0,0-.55-.62H56.55a.61.61,0,0,0-.59.62l-.24,6.38a.57.57,0,0,0,.55.62h1.46a.6.6,0,0,0,.59-.62'
					transform='translate(0 0.02)'
					fill='#cfd2d3'
				/>
				<g>
					<g clip-path='url(#g)'>
						<g>
							<path
								d='M54,25.82l-.94-1a2.12,2.12,0,0,1,.65-1.44l.94,1A2.12,2.12,0,0,0,54,25.82'
								transform='translate(0 0.02)'
								fill='#747476'
							/>
							<path
								d='M54.61,24.38l-.94-1a2,2,0,0,1,.27-.22l.94,1a2,2,0,0,0-.27.22'
								transform='translate(0 0.02)'
								fill='#79797a'
							/>
							<path
								d='M54.88,24.16l-.94-1,.25-.15.94,1-.25.15'
								transform='translate(0 0.02)'
								fill='#7d7e7f'
							/>
							<path
								d='M55.13,24l-.94-1,.25-.1.94,1-.25.1'
								transform='translate(0 0.02)'
								fill='#808182'
							/>
							<path
								d='M55.38,23.91l-.94-1a1.11,1.11,0,0,1,.26-.07l.94,1-.26.08'
								transform='translate(0 0.02)'
								fill='#858587'
							/>
							<path
								d='M55.64,23.83l-.94-1a1.06,1.06,0,0,1,.31,0l.94,1a1.55,1.55,0,0,0-.31,0'
								transform='translate(0 0.02)'
								fill='#898a8b'
							/>
							<path d='M56,23.8l-.94-1h.09l.95,1H56' transform='translate(0 0.02)' fill='#8e8e90' />
						</g>
					</g>
				</g>
			</g>
			<g>
				<polygon points='65.9 23.99 65.5 34.96 63.49 34.96 63.9 23.99 65.9 23.99' fill='#cfd2d3' />
				<polygon
					points='63.49 34.96 62.55 33.99 62.95 23.02 63.9 23.99 63.49 34.96'
					fill='#707071'
				/>
				<polygon points='63.9 23.99 62.95 23.02 64.96 23.02 65.9 23.99 63.9 23.99' fill='#929394' />
			</g>
			<g>
				<g>
					<g clip-path='url(#h)'>
						<g>
							<path
								d='M72.44,33.19l-.94-1h0l.94,1h0'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
							<path
								d='M72.48,33.19l-.94-1h.09l1,1h-.1'
								transform='translate(0 0.02)'
								fill='#898a8b'
							/>
							<path
								d='M72.58,33.18l-1-1,.08,0,.94,1-.07,0'
								transform='translate(0 0.02)'
								fill='#858587'
							/>
							<path
								d='M72.65,33.16l-.94-1,.07,0,.94,1-.07,0'
								transform='translate(0 0.02)'
								fill='#808182'
							/>
							<path
								d='M72.72,33.13l-.94-1,.06,0,1,1-.07,0'
								transform='translate(0 0.02)'
								fill='#7d7e7f'
							/>
							<path
								d='M72.79,33.09l-1-1a.18.18,0,0,0,.07,0l.94,1-.06.05'
								transform='translate(0 0.02)'
								fill='#79797a'
							/>
							<path
								d='M72.85,33l-.94-1a.67.67,0,0,0,.19-.46l.94,1a.64.64,0,0,1-.19.46'
								transform='translate(0 0.02)'
								fill='#747476'
							/>
						</g>
					</g>
				</g>
				<polygon
					points='71.36 33.22 70.42 32.24 71.5 32.24 72.44 33.22 71.36 33.22'
					fill='#929394'
				/>
				<polygon
					points='73.09 31.38 72.14 30.41 74.14 30.41 75.08 31.38 73.09 31.38'
					fill='#929394'
				/>
				<polygon points='73.04 32.6 72.1 31.64 72.14 30.41 73.09 31.38 73.04 32.6' fill='#707071' />
				<g>
					<g clip-path='url(#i)'>
						<g>
							<path d='M71,33l-.94-1,0,0,.94,1,0,0' transform='translate(0 0.02)' fill='#8e8e90' />
							<path
								d='M71,33.07l-.94-1a.53.53,0,0,0,.25.12l.94,1a.53.53,0,0,1-.25-.12'
								transform='translate(0 0.02)'
								fill='#929394'
							/>
							<path
								d='M71.27,33.19l-.94-1h.09l.94,1h-.09'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
						</g>
					</g>
				</g>
				<g>
					<g clip-path='url(#j)'>
						<g>
							<path
								d='M69.34,34.53l-.94-1a1.94,1.94,0,0,1-.55-1.44l.94,1a1.94,1.94,0,0,0,.55,1.44'
								transform='translate(0 0.02)'
								fill='#747476'
							/>
						</g>
					</g>
				</g>
				<polygon
					points='73.23 27.58 72.28 26.61 72.33 25.35 73.27 26.32 73.23 27.58'
					fill='#707071'
				/>
				<g>
					<g clip-path='url(#k)'>
						<g>
							<path
								d='M73.27,26.3l-.94-1a.6.6,0,0,0-.16-.46l.94,1a.6.6,0,0,1,.16.46'
								transform='translate(0 0.02)'
								fill='#747476'
							/>
						</g>
					</g>
				</g>
				<g>
					<g clip-path='url(#l)'>
						<g>
							<path
								d='M73.33,23.77l-.94-1,.32,0,.94,1-.32,0'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
							<path
								d='M73.65,23.79l-.94-1a1.94,1.94,0,0,1,.94.43l.95,1a2,2,0,0,0-.95-.43'
								transform='translate(0 0.02)'
								fill='#929394'
							/>
							<path
								d='M74.6,24.22l-.95-1a.86.86,0,0,1,.14.13l.94,1-.13-.13'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
						</g>
					</g>
				</g>
				<polygon
					points='68.79 33.11 67.85 32.14 68.12 24.87 69.06 25.84 68.79 33.11'
					fill='#707071'
				/>
				<polygon
					points='71.13 23.79 70.19 22.82 72.39 22.82 73.33 23.79 71.13 23.79'
					fill='#929394'
				/>
				<g>
					<g clip-path='url(#m)'>
						<g>
							<path
								d='M69.06,25.82l-.94-1a2.2,2.2,0,0,1,.65-1.48l1,1a2.17,2.17,0,0,0-.66,1.48'
								transform='translate(0 0.02)'
								fill='#747476'
							/>
							<path
								d='M69.72,24.34l-1-1a2.47,2.47,0,0,1,.27-.21l.94,1a1.71,1.71,0,0,0-.26.21'
								transform='translate(0 0.02)'
								fill='#79797a'
							/>
							<path
								d='M70,24.13l-.94-1a1.58,1.58,0,0,1,.24-.15l1,1a1.28,1.28,0,0,0-.25.15'
								transform='translate(0 0.02)'
								fill='#7d7e7f'
							/>
							<path
								d='M70.23,24l-1-1,.25-.1.94,1a1.73,1.73,0,0,0-.24.1'
								transform='translate(0 0.02)'
								fill='#808182'
							/>
							<path
								d='M70.47,23.88l-.94-1,.26-.07.94,1-.26.07'
								transform='translate(0 0.02)'
								fill='#858587'
							/>
							<path
								d='M70.73,23.81l-.94-1,.3,0,.94,1a1.54,1.54,0,0,0-.3,0'
								transform='translate(0 0.02)'
								fill='#898a8b'
							/>
							<path
								d='M71,23.77l-.94-1h.09l.95,1H71'
								transform='translate(0 0.02)'
								fill='#8e8e90'
							/>
						</g>
					</g>
				</g>
				<path
					d='M73.33,23.77a1.93,1.93,0,0,1,2,2.05l-.06,1.74h-2l0-1.26a.56.56,0,0,0-.55-.62H71.63a.62.62,0,0,0-.58.62l-.23,6.28a.55.55,0,0,0,.54.61h1.08a.59.59,0,0,0,.6-.61l0-1.22h2L75,33.09a2.1,2.1,0,0,1-2.1,2h-2.2a1.92,1.92,0,0,1-1.92-2l.27-7.27a2.1,2.1,0,0,1,2.07-2.05Z'
					transform='translate(0 0.02)'
					fill='#cfd2d3'
				/>
			</g>
			<g>
				<polygon
					points='79.83 33.11 78.89 32.14 82.16 32.14 83.1 33.11 79.83 33.11'
					fill='#929394'
				/>
				<polygon points='80 28.58 79.05 27.61 81.36 27.61 82.31 28.58 80 28.58' fill='#929394' />
				<polygon
					points='83.34 23.99 83.27 25.84 80.1 25.84 80 28.58 82.31 28.58 82.24 30.28 79.93 30.28 79.83 33.11 83.1 33.11 83.03 34.96 77.75 34.96 78.16 23.99 83.34 23.99'
					fill='#cfd2d3'
				/>
				<polygon
					points='77.75 34.96 76.81 33.99 77.22 23.02 78.16 23.99 77.75 34.96'
					fill='#707071'
				/>
				<polygon
					points='78.16 23.99 77.22 23.02 82.39 23.02 83.34 23.99 78.16 23.99'
					fill='#929394'
				/>
				<text font-family='Bourgeois-MediumCondensed' fill='white' x='40' y='63' font-size='20px'>
					{text}
				</text>
			</g>
		</svg>
	);
};
